import aesReduxConstants from '../../constants';

const userInfoReducer = function() {
  const defaultState = {
    userId: null,
    clientId: null,
    roleId: null,
    locationSetId: null,
    mapSettings: null,
    firstName: null,
    lastName: null,
    ackEnabled: false,
    betaFeatureList: [],
  };

  const getPreferences = session => ({
    ...session.preferences,
    tz: session.tz,
  });

  const reducer = function(state, action) {
    const constants = aesReduxConstants;

    if (state === undefined) state = defaultState;

    let delta = {};
    switch (action.type) {
      case constants.SET_USER_SESSION:
        delta = {
          userId: action.sessionData.userId,
          clientId: action.sessionData.clientId,
          locationSetId: action.sessionData.locationSetId,
          mapSettings: action.sessionData.mapSettings,
          roleId: action.sessionData.roleId,
          firstName: action.sessionData.firstName,
          lastName: action.sessionData.lastName,
          ackEnabled: action.sessionData.ackEnabled,
          betaFeatureList: action.sessionData.betaFeatureList,

          // get preferences is used to merge some things
          preferences: getPreferences(action.sessionData),
        };
        break;
      case constants.USER.SET_LOCATION_SET_ID:
        delta = {
          locationSetId: action.locationSetId,
        };
        break;
      case `${constants.MAP.BASEMAP.SET_DEFAULT}_SUCCESS`:
        delta = {
          mapSettings: Object.assign({}, state.mapSettings, {
            basemap: action.payload,
          }),
        };
        break;
      default:
        return state;
    }

    return Object.assign({}, state, delta);
  };

  return reducer;
};

export default userInfoReducer();
